export const SERIES_COLORS = ["#17384c", "#05bbe5", "#e8a317", "#7c5cd6", "#2e9e5b", "#d64545", "#64748b"];
export const SLA_COLORS = { green: "#2e9e5b", amber: "#e8a317", red: "#d64545" } as const;
